import { createSelector } from 'reselect';
import { connectRouter } from 'connected-react-router';

export const STATE_KEY = 'router';

export default function router(history) {
  return connectRouter(history);
}

/*
 * Getters
 */

export const getState = (state) => state[STATE_KEY];
export const getRouterLocation = (state) => getState(state).location;

export const routerGetters = {
  getState,
  getRouterLocation,
};

/*
 * Selectors
 */

export const selectRouterLocation = createSelector(getRouterLocation, (c) => c);

export const routerSelectors = {
  selectRouterLocation,
};
